import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { MessageService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { catchError, throwError } from 'rxjs';
import { failuresFromResponse, resolveFailureMessage } from '../models/failure.model';
import { isAuthFailureStatus } from '../constants/auth-failure-status';
import { ErrorToastSuppressionService } from '../services/error-toast-suppression.service';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const messageService = inject(MessageService);
  const translate = inject(TranslateService);
  const errorToastSuppression = inject(ErrorToastSuppressionService);

  return next(req).pipe(
    catchError(error => {
      if (error instanceof HttpErrorResponse) {
        if (!isAuthFailureStatus(error.status) && !errorToastSuppression.active) {
          messageService.clear();
          messageService.add({
            severity: 'error',
            summary: translate.instant('common.error'),
            detail: resolveFailureMessage(translate, failuresFromResponse(error)[0]),
          });
        }
      }
      return throwError(() => error);
    }),
  );
};
